/* eslint-disable @typescript-eslint/no-explicit-any -- TODO: Clean !!! */
/* eslint-disable angular/module-getter */
import { __decorate } from "tslib";
import { Injectable, NgZone } from '@angular/core';
import debug from 'debug';
import * as HTTP from 'http-status-codes';
import { Subject, fromEvent, BehaviorSubject } from 'rxjs';
import { first, share, tap } from 'rxjs/operators';
import io from '../../../sails.io.config';
import { SailsSocketModule } from './sails-socket.module';
const _window = window;
let SailsSocketService = class SailsSocketService {
    zone;
    _io;
    _connected = false;
    _opts = {};
    _restPrefix = '';
    _serverUrl = '';
    _pubsubSubscriptions;
    log = debug('sails');
    connection = new BehaviorSubject({
        connected: false,
        url: this.serverUrl,
        opts: this._opts
    });
    constructor(zone) {
        this.zone = zone;
        this._pubsubSubscriptions = {};
        this._opts = {
            url: ''
        };
        this.log.log = console.log.bind(console);
    }
    /**
     *
     * @returns {string}
     */
    get restPrefix() {
        return this._restPrefix;
    }
    set restPrefix(value) {
        if (value?.length > 0) {
            if (value.charAt(value.length - 1) === '/') {
                value = value.substr(0, value.length - 1);
            }
            this._restPrefix = value;
        }
    }
    /**
     *
     * @returns {string}
     */
    get serverUrl() {
        return this._serverUrl;
    }
    set serverUrl(value) {
        if (value?.length > 0) {
            if (value.charAt(value.length - 1) === '/') {
                value = value.substr(0, value.length - 1);
            }
            this._serverUrl = value;
        }
    }
    disconnect() {
        if (this._io && this._io.sails && this._io.socket && this._io.socket.isConnected) {
            console.log('$$$$$$ disconnect()');
            // TODO: Should we call disconnect??
            //  this._io.disconnect();
        }
    }
    connect(url, opts) {
        const subject = new Subject();
        subject.subscribe(this.connection);
        if (this._io && this._io.sails && this._io.socket && this._io.socket.isConnected) {
            this._io.disconnect();
        }
        // URL optional
        if (typeof url === 'object') {
            this._opts = Object.assign({}, url);
            url = '';
        }
        if (typeof opts === 'object') {
            this._opts = Object.assign({}, opts);
        }
        if (url) {
            this.serverUrl = url;
        }
        else if (this._opts.url) {
            this.serverUrl = this._opts.url;
        }
        else if (!(this._serverUrl && this._serverUrl.length > 0)) {
            this._serverUrl = '';
        }
        this._opts.url = this._serverUrl;
        const doConnection = () => {
            this._io = io.sails.connect(this._opts);
            if (this._io && this._io.sails && this._io.socket && this._io.socket.isConnected) {
                this._connected = true;
            }
            else {
                this._connected = false;
                subject.next({
                    connected: false,
                    url: this.serverUrl,
                    opts: this._opts
                });
            }
            this._io.on('connect_error', () => {
                this.log('Connection failed');
                subject.next({
                    connected: false,
                    url: this.serverUrl,
                    opts: this._opts
                });
            });
            this._io.on('reconnect_failed', () => {
                this.log('Client has not reconnected to the server!');
                subject.next({
                    connected: false,
                    url: this.serverUrl,
                    opts: this._opts
                });
            });
            this._io.on('reconnected', () => {
                this.log('Client has reconnected to the server!');
                subject.next({
                    connected: true,
                    url: this.serverUrl,
                    opts: this._opts
                });
            });
            // Add a connect listener
            this._io.on('connect', () => {
                this.log('Client has connected to the server!');
                subject.next({
                    connected: true,
                    url: this.serverUrl,
                    opts: this._opts
                });
                // subject.complete();
            });
            this._io.on('disconnect', () => {
                this.log('Client has disconnected to the server!');
                subject.next({
                    connected: false,
                    url: this.serverUrl,
                    opts: this._opts
                });
                // subject.complete();
            });
        };
        // if the angular-sails (angularjs) is currently trying to connect, allow it to finish so that its
        // connection event isn't intercepted/overwritten
        if (_window.$sails?.isConnecting?.()) {
            _window.$sails.on('connect', doConnection);
        }
        else {
            doConnection();
        }
        return subject.asObservable();
    }
    /**
     * Send a virtual request to a Sails server using Socket.io.
     * This function is very similar to .get(), .post(), etc.
     * except that it provides lower-level access to the request headers, parameters,
     * method, and URL of the request
     *
     * @function request
     * @param {*} options
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    request(options) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.request(options, (resData, jwres) => {
                    this.log('request::data', resData);
                    this.log('request:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {string} url
     * @param {*} [data]
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    get(url, data) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.get(`${this._restPrefix}${url}`, data, (resData, jwres) => {
                    this.log('get::data', resData);
                    this.log('get:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {*} url
     * @param {*} [data]
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    post(url, data) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.post(url, data, (resData, jwres) => {
                    this.log('post::data', resData);
                    this.log('post:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {*} url
     * @param {*} [data]
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    put(url, data) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.put(url, data, (resData, jwres) => {
                    this.log('put::data', resData);
                    this.log('put:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {*} url
     * @param {*} [data]
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    patch(url, data) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.patch(url, data, (resData, jwres) => {
                    this.log('patch::data', resData);
                    this.log('patch:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {*} url
     * @param {*} [data]
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    delete(url, data) {
        const subject = new Subject();
        this.zone.runOutsideAngular(() => {
            this.onceConnected(() => {
                this._io.delete(url, data, (resData, jwres) => {
                    this.log('delete::data', resData);
                    this.log('delete:jwr', jwres);
                    const msg = {
                        data: resData,
                        statusCode: jwres.statusCode,
                        response: jwres,
                    };
                    if (jwres.statusCode < HTTP.OK || jwres.statusCode >= HTTP.BAD_REQUEST) {
                        this.zone.run(() => subject.error({
                            ...msg,
                            error: jwres.error
                        }));
                    }
                    else {
                        this.zone.run(() => subject.next(msg));
                    }
                    subject.complete();
                });
            });
        });
        return subject.asObservable();
    }
    /**
     * @param {string} eventIdentity
     * @returns {Observable<any>}
     * @memberof SailsSocketService
     */
    on(eventIdentity) {
        if (!this._pubsubSubscriptions[eventIdentity] || this._pubsubSubscriptions[eventIdentity].isComplete) {
            this.log('creating on listener: ', eventIdentity);
            this.zone.runOutsideAngular(() => {
                this._pubsubSubscriptions[eventIdentity] = fromEvent(this._io, eventIdentity)
                    .pipe(tap((msg) => {
                    this.log(`tap:on::${eventIdentity}`, msg);
                    this.log('inAngularZone: ', NgZone.isInAngularZone());
                }), share());
            });
        }
        return this._pubsubSubscriptions[eventIdentity];
    }
    onceConnected(obs) {
        this.connection
            .pipe(first(({ connected }) => connected))
            .subscribe(obs);
    }
    static ctorParameters = () => [
        { type: NgZone }
    ];
};
SailsSocketService = __decorate([
    Injectable({
        providedIn: SailsSocketModule,
    })
], SailsSocketService);
export { SailsSocketService };
